var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"action-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.generatePdf.apply(null, arguments)}}},[_c('img',{attrs:{"src":"/images/featured/document-download-morado.svg","alt":"download"}}),(_vm.isGenerating)?_c('span',[_vm._v("Generando PDF...")]):_c('span',[_vm._v("Descargar como PDF")])])
}
var staticRenderFns = []

export { render, staticRenderFns }